export default {
  namespaced: true,
  policy_exception: {
    title: 'exceção de política | exceções de política',
    reference_number: 'Número de referência',
    scope_type: 'Tipo de escopo',
    coverage: 'Cobertura',
    scope: 'Escopo',
    status: 'Estado',
    request_type: 'Tipo de solicitação',
    assigned_to: 'Atribuído a',
    in_review: 'Em revisão',
    approved_canceled: 'Aprovado/Rejeitado',
    request_date: 'Data da solicitação',
    start_date: 'Data de início',
    end_date: 'Data de término',
    regulatory_required: 'Requisito regulatório',
    regulation_description: 'Descrição da regulamentação',
    exception_type: 'Tipo de exceção',
    source: 'Origem',
    inherent_risk: 'Risco inerente',
    residual_risk: 'Risco residual',
    select_exception_type: 'Selecionar tipo de exceção',
    select_status: 'Selecionar estado',
    select_source: 'Selecionar origem',
    select_inherent_risk: 'Selecionar risco inerente',
    select_residual_risk: 'Selecionar risco residual',
    units: 'Imóveis',
    unit: 'Unidade',
    inmuebles: 'Imóveis',
    regions: 'Regiões',
    created_from: 'Criado de',
    created_to: 'Criado até',
    validity_from: 'Vigência de',
    validity_to: 'Vigência até',
    municipalities: 'Municípios',
    sectors: 'Setores',
    standards: 'Padrões',
    standards_affected: 'Padrões afetados',
    select_standards: 'Selecionar padrões',
    description: 'Descrição da exceção',
    compensatory_measures: 'Medidas compensatórias',
    justification: 'Justificação da exceção',
    section_detail: 'Detalhe seção/subseção do padrão',
    section_attachments: 'Anexos da seção/subseção',
    approver_soeid: 'Aprovador (SOEID)',
    attachments: 'Anexar arquivos',
    attachments_accepted_types: 'Imagens, PDF, Word, Excel, ZIP.',
    save_to_view_files: 'Salve as alterações para visualizar os arquivos',
    pending_save: 'pendente de salvar',
    history: 'Histórico',
    history_state: 'Estado',
    history_user: 'Usuário',
    history_date: 'Data',
    risk_level_table_level: 'Nível',
    risk_level_table_description: 'Descrição',
    risk_table_title: 'Tabela de riscos',
    show_risk_table: 'Mostrar tabela de riscos',
    risk_level_critical: 'Crítico',
    risk_level_critical_desc: 'Exceções de descumprimento de Normas de Segurança ou Riscos de Segurança que, após considerar os controles compensatórios e fatores mitigadores, podem representar um risco crítico quando uma instalação é vulnerável a um impacto catastrófico na segurança/proteção ou na operação.',
    risk_level_high: 'Alto',
    risk_level_high_desc: 'Exceções de descumprimento de Normas de Segurança ou Riscos de Segurança que, após considerar os controles compensatórios e fatores mitigadores, podem representar um risco significativo para múltiplas instalações ou processos, comprometendo o impacto em segurança/proteção ou operacional.',
    risk_level_medium: 'Médio',
    risk_level_medium_desc: 'Exceções de descumprimento de Normas de Segurança ou Riscos de Segurança que, após considerar os controles compensatórios e fatores mitigadores, podem representar um risco moderado para uma instalação ou processo; comprometendo o impacto em segurança/proteção ou operacional.',
    risk_level_low: 'Baixo',
    risk_level_low_desc: 'Exceções de descumprimento de Normas de Segurança ou Riscos de Segurança que, após considerar os controles compensatórios e fatores mitigadores, poderiam ter um efeito adverso insignificante sobre uma instalação, sua operação e seu pessoal.',
    status_in_progress: 'Em progresso',
    status_in_review: 'Em revisão',
    status_approved: 'Aceito',
    status_rejected: 'Rejeitado',
    status_reassigned: 'Reatribuído',
    status_canceled: 'Cancelado',
    status_scheduled: 'Programado',
    nacional: 'Nacional',
    select_scope_type: 'Selecionar tipo de escopo',
    select_request_type: 'Selecionar tipo de solicitação',
    select_units: 'Selecionar imóveis',
    select_municipalities: 'Selecionar municípios',
    select_sectors: 'Selecionar setores',
    select_user: 'Selecionar usuário',
    select_reviewer: 'Selecionar revisor',
    select_reviewer_first: 'Selecione um revisor primeiro',
    btn_send_to_review: 'Enviar para revisão',
    unable_to_load: 'Não foi possível carregar a exceção de política.',
    one_required_field_missing: '1 campo obrigatório está faltando',
    multiple_required_fields_missing: '{count} campos obrigatórios estão faltando',
    last_field: 'Última',
    comments: 'Comentários',
    comments_placeholder: 'Comentários opcionais',
    renew_exception: 'Renovar Exceção',
    close_exception: 'Fechar Exceção',
    change_assignee: 'Mudança de Atribuído',
    close_reason: 'Motivo do fechamento',
    close_exception_message: 'O formulário ficará somente leitura e a exceção será fechada.',
    close_reason_placeholder: 'Informe o motivo do fechamento',
    start_date_must_be_after_request_date: 'A data de início deve ser maior ou igual à data da solicitação',
    end_date_must_be_after_start_date: 'A data de término deve ser maior ou igual à data de início',
    end_date_must_be_after_request_date: 'A data de término deve ser estritamente maior que a data da solicitação',
    conflict_inmuebles_in_progress: 'Conflito de imóveis',
    conflict_inmueble_in_policy: 'O imóvel {unitLabel} está ativo na exceção de política {referenceNumber} (tipo: {exceptionTypeName}).',
    workflow: {
      submit: 'Enviar',
      approve: 'Aprovar',
      reject: 'Rejeitar',
      cancel: 'Cancelar',
      reassign: 'Reatribuir',
      submit_title: 'Enviar para revisão',
      approve_title: 'Aprovar exceção',
      reject_title: 'Rejeitar exceção',
      cancel_title: 'Cancelar exceção',
      reassign_title: 'Reatribuir a usuário',
      confirm_title: 'Confirmar',
      submit_message: 'Enviar esta exceção para revisão?',
      approve_message: 'Aprovar esta exceção de política?',
      reject_message: 'Rejeitar esta exceção de política?',
      cancel_message: 'Cancelar esta exceção de política?',
      confirm_message: 'Confirmar esta ação para {ref}?',
    },
  },
}
